import { render, staticRenderFns } from "./groupNew.vue?vue&type=template&id=230ee24c"
import script from "./groupNew.vue?vue&type=script&lang=js"
export * from "./groupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports